import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './Button';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 sm:py-24 px-4 border-t border-green-700/20" data-id="element-59">
      <div className="max-w-3xl mx-auto text-center" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-61">
          <div className="w-24 h-1 bg-white/20 mx-auto mb-8 sm:mb-12" data-id="element-62"></div>

          <h2 className="text-3xl sm:text-4xl font-black text-white mb-6 leading-tight drop-shadow-lg uppercase" data-id="element-63">
            ¿LISTO/A PARA ORDENAR TU NEGOCIO Y EMPEZAR A VENDER MEJOR POR
            INTERNET?
          </h2>

          <div className="bg-green-950/60 p-8 rounded-3xl border border-green-600/25 mb-10 shadow-xl" data-id="element-64">
            <h3 className="text-xl font-bold text-white mb-2 uppercase" data-id="element-65">
              Método Venta Flash IA
            </h3>
            <p className="text-white/70 font-medium mb-6" data-id="element-66">
              5 Tomos + 3 Bonos + Acceso inmediato
            </p>

            <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-67">
              <span className="text-2xl text-white/40 line-through font-bold" data-id="element-68">
                Valor real: $64.990
              </span>
              <span className="text-5xl font-black text-yellow-300 drop-shadow-lg" data-id="element-69">
                Hoy: $19.990
              </span>
            </div>

            <Button href="https://checkout.guiadigital360.online/cart/44839939866693:1" className="w-full py-5 text-xl sm:text-2xl mb-6 shadow-xl" data-id="element-70">
              QUIERO MI MEGA PACK AHORA <ArrowRight className="w-6 h-6" data-id="element-71" />
            </Button>

            <div className="flex flex-wrap justify-center items-center gap-4 text-sm font-bold text-white/80 uppercase" data-id="element-72">
              <span data-id="element-73">Pago seguro</span>
              <span className="hidden sm:inline" data-id="element-74">·</span>
              <span data-id="element-75">Acceso inmediato</span>
              <span className="hidden sm:inline" data-id="element-76">·</span>
              <span data-id="element-77">Garantía de 7 días</span>
            </div>
          </div>

          <div className="text-white/80 font-medium" data-id="element-78">
            <p className="mb-1" data-id="element-79">¿Tenés dudas? Escribinos a:</p>
            <a href="mailto:soporteguiadigital360@gmail.com" className="text-yellow-300 font-bold hover:underline" data-id="element-80">
              soporteguiadigital360@gmail.com
            </a>
          </div>

          <div className="w-24 h-1 bg-white/20 mx-auto mt-12" data-id="element-81"></div>
        </motion.div>
      </div>
    </section>;
}